/**
  * @ngdoc overview
  * @name help.module:help
  * @requires cms.module:cms
  * @description
  * Help module
  * 
  * Routes definition and parameters configurations.
  * States:
  * - menu
  * - submenu
  * - content
  * 
*/
(function () {

    'use strict';

    angular.module('itxApp.help', [ 
        'ui.router',
        'itxApp.common', 
        'itxApp.catalog'
    ])
    .config(XConfig)
    .config(Router);

    Router.$inject = [
        '$stateProvider',
        '$urlRouterProvider'
    ];

    function Router(
        $stateProvider,
        $urlRouterProvider
    ) {

        $stateProvider.state('menu', {
            url: '/',
            component: 'itxHelpMenu',
            resolve: {
                covid: function(helpService){
                    return helpService.cleanCovid();
                },
                menu: function(helpService){
                    return helpService.getMenu();
                }
            }
        });

        $stateProvider.state('ticketToInvoice', {
            url: '/ticket-to-invoice',
            component: 'itxTicketInvoice',
            resolve: {
                covid: function(helpService){
                    return helpService.cleanCovid();
                }
            }
        });

        $stateProvider.state('submenu', {
            url: '/:submenu',
            component: 'itxHelpSubmenu',
            resolve: {
                covid: function(helpService){
                    return helpService.cleanCovid();
                },
                submenu: function(helpService,$transition$,$state){
                    return helpService.getSubmenu($transition$.params().submenu).then(function(submenu){
                        if(submenu.length === 1){
                            $state.go('content', {submenu:$transition$.params().submenu, contentDest: 'open'});
                        }
                        
                        return submenu;
                    });
                }
            }
        });

        $stateProvider.state('content', {
            url: '/:submenu/:contentDesc',
            component: 'itxHelpContent',
            resolve: {
                covid: function(helpService){
                    return helpService.cleanCovid();
                },
                content: function(helpService,$transition$,$stateParams){
                    if( $stateParams &&  $stateParams.contentDesc === 'COVID-19' ){
                        $('#help-page-main').addClass('covid-19');
                    }
                    if( $stateParams &&  ($stateParams.contentDesc === 'opened-stores' || 
                    $stateParams.contentDesc === 'COVID-19')){
                        $('#help-page-main').addClass('covid-19-2');
                    }
                    return helpService.getHelpContent(  $transition$.params().submenu,  $transition$.params().contentDesc);
                }
            }
        });

        $stateProvider.state('tickettoinvoice', {
            url: '/ticket/to/invoice',
            component: 'itxTicketInvoice',
            resolve: {
                covid: function(helpService){
                    return helpService.cleanCovid();
                }
            }
        });

        $urlRouterProvider.when('', '/');
    }

    function XConfig() {
        if (inditex.iXconfVars) {
            inditex.iXconfVars.push(
                'ENABLED_NUM_PHYSICAL_STORES_BY_STORE',
                'MAX_NUM_PHYSICAL_STORES'
            );
        } else {
            inditex.iXconfVars = [
                'ENABLED_NUM_PHYSICAL_STORES_BY_STORE',
                'MAX_NUM_PHYSICAL_STORES'
            ];
        }
    }

})();
